import { useEffect } from 'react';

import { useShortcutMenu } from './useShortcutMenu';

export const useAutoSelectFirstCommandItem = (firstItemValue: string | undefined) => {
    const { setSelectedValue } = useShortcutMenu();

    useEffect(() => {
        setSelectedValue(firstItemValue);
    }, [firstItemValue, setSelectedValue]);
};
